import { redirect } from "react-router-dom";

export function getTokenDuration(){
    const storedExpirationDate = localStorage.getItem('expiration')
    const expirationDate = new Date(storedExpirationDate);
    const now = new Date();
    const duration = expirationDate.getTime() - now.getTime();
    return duration;
}

export function getAuthToken(){
    const token = localStorage.getItem('token');

    if(!token || token === undefined){
        return null;
    }

    const tokenDuration = getTokenDuration();

    if(tokenDuration <0 || tokenDuration === undefined){
        return null;
    }

    return token;
}

export function tokenLoader(){
    return getAuthToken();
}

export async function checkToken()
{
    const token = getAuthToken();

    if(token === null){
        return redirect('/auth');
    }

    return null;
}